<template>
  <v-layout child-flex>
      <!-- <PricingFilter/> -->
      <PricingTableSmall />
  </v-layout>
</template>

<script>
// import PricingFilter from "@/components/PricingFilter.vue";
import PricingTableSmall from "@/components/PricingTableSmall.vue";

export default {
  name: "Table",
  components: {
    // PricingFilter,
    PricingTableSmall
  }
};
</script>
